// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__l1mdY","rootNoMargin":"styles_rootNoMargin__1DoxR"};